<ion-card class="action-card skinny-card">
  <ion-list class="no-padding transparent-bg">
    <ion-item class="box-header-item">
      <ion-badge
        [color]="step.type === 'branches' ? 'secondary' : 'tertiary'"
        slot="start"
        style="margin-right: 12px; font-size: 1.2rem"
      >
        <ion-icon
          [name]="
            step.type === 'branches' ? 'git-branch-outline' : AUTOMATION_ACTION_TYPES_ICONS[step.data.action.type]
          "
        ></ion-icon>
      </ion-badge>
      <ion-label>
        <p style="margin: 0; font-size: 0.7rem">Step {{ index + 1 }}</p>
        <h3 style="margin: 0 0 4px 0; font-weight: 500">
          {{ step.type === 'branches' ? 'Branch' : AUTOMATION_ACTION_TYPES_LABELS[step.data.action.type] }}
        </h3>
      </ion-label>
      <ion-icon *ngIf="canDrag" name="reorder-two-outline" slot="end" style="cursor: grab"></ion-icon>
      <ion-button slot="end" fill="clear" color="dark" (click)="handleOptionsClick()" class="item-accessory-button">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>

  <ng-container *ngIf="step.type === 'action'">
    <ng-container [ngSwitch]="step.data.action.type">
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.CREATE_APPROVAL_REQUEST">
        <ion-label class="input-label">Send to user or team</ion-label>
        <br />
        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectAssignee(step.data.action.data)"
        >
          <ion-label>
            {{
              lookups?.['assigneeId']?.[step.data.action.data.entityId] ??
                lookups?.['groupId']?.[step.data.action.data.entityId] ??
                lookups?.['userGroupId']?.[step.data.action.data.entityId] ??
                'No one'
            }}
            <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.ASSIGN_CONVERSATION">
        <div>
          <ion-label class="input-label">Assign to user or team</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                step.data.action.data.entityId
                  ? getResolvableEntityLabel(step.data.action.data.entityId)
                  : 'Select user or user group field'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific User Selection (Conditional) -->
        <div style="margin-top: 10px" *ngIf="showSpecificEntitySelection(step.data.action.data, 'entityId')">
          <ion-label class="input-label">Select Specific User or User Group</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectSpecificEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                lookups?.['assigneeId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  lookups?.['groupId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  lookups?.['userGroupId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  'Select user or user group'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_FOLLOWER">
        <ion-label class="input-label">Add user or team</ion-label>
        <br />

        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectAssignee(step.data.action.data)"
        >
          <ion-label>
            {{
              lookups?.['assigneeId']?.[step.data.action.data.entityId] ??
                lookups?.['groupId']?.[step.data.action.data.entityId] ??
                lookups?.['userGroupId']?.[step.data.action.data.entityId] ??
                'No one'
            }}
            <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CONVERSATION_COLLABORATOR">
        <div>
          <ion-label class="input-label">Set collaborator type</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectCollaboratorType(step.data.action.data)"
          >
            <ion-label>
              {{
                lookups?.['collaboratorTypeId']?.[step.data.action.data.collaboratorTypeId] ??
                  'Select collaborator type'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Collaborator to Add</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                step.data.action.data.entityId
                  ? getResolvableEntityLabel(step.data.action.data.entityId)
                  : 'Select user or user group field'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific User Selection (Conditional) -->
        <div style="margin-top: 10px" *ngIf="showSpecificEntitySelection(step.data.action.data, 'entityId')">
          <ion-label class="input-label">Select Specific User or User Group</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectSpecificEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                lookups?.['assigneeId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  lookups?.['groupId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  lookups?.['userGroupId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  'Select user or user group'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CONVERSATION_PRIORITY">
        <div class="flexed">
          <div
            *ngFor="let option of priorityOptionsForTemplate; let first = first; let last = last"
            class="round-pill-tab"
            [ngClass]="{
              'round-pill-tab-left': first,
              'round-pill-tab-right': last,
              'round-pill-tab-active': step.data.action.data.priority === option.value
            }"
            (click)="step.data.action.data.priority = option.value; handleActionChange()"
          >
            {{ option.label }}
          </div>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_STATUS">
        <div class="flexed">
          <div
            class="round-pill-tab round-pill-tab-left"
            [ngClass]="{
              'round-pill-tab-active': step.data.action.data.status === 'open'
            }"
            (click)="step.data.action.data.status = 'open'"
          >
            <ion-icon name="custom-open" class="status-label-needs-response"></ion-icon>
            Needs response
          </div>
          <div
            class="round-pill-tab"
            [ngClass]="{
              'round-pill-tab-active': step.data.action.data.status === 'in_progress'
            }"
            (click)="step.data.action.data.status = 'in_progress'"
          >
            <ion-icon name="custom-in-progress" class="status-label-in-progress"></ion-icon>
            In progress
          </div>
          <div
            class="round-pill-tab"
            [ngClass]="{
              'round-pill-tab-active': step.data.action.data.status === 'on_hold'
            }"
            (click)="step.data.action.data.status = 'on_hold'"
          >
            <ion-icon name="custom-on-hold" class="status-label-on-hold"></ion-icon>
            On hold
          </div>
          <div
            class="round-pill-tab round-pill-tab-right"
            [ngClass]="{
              'round-pill-tab-active': step.data.action.data.status === 'closed'
            }"
            (click)="step.data.action.data.status = 'closed'"
          >
            <ion-icon name="custom-closed" class="status-label-closed"></ion-icon>
            Closed
          </div>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_SUB_STATUS">
        <div class="flexed">
          <div>
            <ion-label class="input-label">Status</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectSubStatus(step.data.action.data)"
            >
              <ion-icon
                *ngIf="getSubStatusIcon(step.data.action.data.subStatusKey)"
                [name]="getSubStatusIcon(step.data.action.data.subStatusKey)"
                [class]="getSubStatusIconClass(step.data.action.data.subStatusKey)"
                style="margin-right: 5px; width: 12.8px; height: 12.8px"
              ></ion-icon>
              <ion-label>
                {{ lookups?.['subStatusKey']?.[step.data.action.data.subStatusKey] ?? 'Select status' }}
                <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>

      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.WAIT">
        <ion-label class="input-label">Delay (in minutes)</ion-label>
        <div class="flexed-align-center">
          <ion-input
            *ngIf="step.data.action.data.wait"
            class="input-field"
            placeholder="Enter minutes"
            [(ngModel)]="step.data.action.data.wait.minutes"
            type="number"
            min="1"
            step="1"
          ></ion-input>
          <ion-toggle
            (ionChange)="toggleWorkingTimeOnly(step.data.action.data)"
            [checked]="step.data.action.data.wait.workingTimeOnly"
          ></ion-toggle>
          <ion-label class="input-label">Working time only</ion-label>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.SEND_SLACK_TEMPLATE">
        <div
          [hidden]="step.data.action.data.templateId"
          style="border-radius: 8px; border: 1px solid var(--ion-border-color)"
        >
          <app-slack-text-editor
            [content]="step.data.action.data.body?.value"
            [isRichText]="false"
            placeholder="Enter message"
            (contentDidChange)="step.data.action.data.body.value = $event"
            [projectId]="projectId ?? undefined"
          ></app-slack-text-editor>
        </div>
        <div *ngIf="step.data.action.data.templateId">
          <ion-spinner
            *ngIf="!lookups?.['templateHtml']?.[step.data.action.data.templateId]"
            name="dots"
            style="margin-top: 10px; margin-bottom: 10px"
          ></ion-spinner>
          <app-slack-message
            *ngIf="lookups?.['templateHtml']?.[step.data.action.data.templateId]"
            [content]="lookups?.['templateHtml']?.[step.data.action.data.templateId]"
          ></app-slack-message>
        </div>
        <div class="flexed" style="margin-top: 15px; padding-top: 10px; border-top: 1px solid var(--ion-border-color)">
          <div>
            <ion-label class="input-label">Use a template</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline"
              [outline]="true"
              (click)="selectTemplate(step.data.action.data)"
              style="width: 100%; margin-left: -1px"
            >
              <ion-label>
                {{ lookups?.['templateId']?.[step.data.action.data.templateId] ?? 'Select template' }}
                <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <div style="width: 50%; margin-left: 8px">
            <ion-label class="input-label">Send as</ion-label>
            <br />
            <ion-select
              mode="ios"
              class="input-field select-outline"
              interface="popover"
              placeholder="Select user"
              aria-label="Send as"
              [(ngModel)]="step.data.action.data.sendAs"
              value="support_team"
              style="
                padding-right: 13px;
                padding-top: 6px;
                padding-bottom: 6px;
                padding-left: 1px;
                font-size: 0.75rem;
                margin-top: 4px;
                padding-left: 11px;
              "
            >
              <ion-select-option value="support_team">Support Team (default)</ion-select-option>
              <ion-select-option value="ticket_assignee">Ticket Assignee</ion-select-option>
            </ion-select>
          </div>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Post message to </ion-label>

          <div class="flexed">
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': !step.data.action.data.entityId
              }"
              (click)="step.data.action.data.entityId = null"
            >
              Main thread
            </div>
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': step.data.action.data.entityId
              }"
              (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
            >
              Direct message
            </div>
          </div>
        </div>

        <div style="margin-top: 10px" *ngIf="step.data.action.data.entityId">
          <ion-label class="input-label">Send a DM to</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectResolvableEntity(step.data.action.data, 'entityId')"
          >
            <ion-label>
              {{
                step.data.action.data.entityId
                  ? getResolvableEntityLabel(step.data.action.data.entityId)
                  : 'Select user or user group field'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific User Selection (Conditional) -->
        <div style="margin-top: 10px" *ngIf="showSpecificEntitySelection(step.data.action.data, 'entityId')">
          <ion-label class="input-label">Select specific user or user group</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectSpecificEntity(step.data.action.data, 'entityId', undefined, true)"
          >
            <ion-label>
              {{
                lookups?.['assigneeId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  lookups?.['groupId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  lookups?.['userGroupId']?.[step.data.action.data.entityId?.value ?? ''] ??
                  'Select user or user group'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_TAGS">
        <ion-chip
          mode="ios"
          class="select-chip select-outline"
          style="margin: 0 5px 0 0"
          [outline]="true"
          *ngFor="let tagId of step.data.action.data.tagIds; let i = index"
          (click)="removeTag(step.data.action.data, i)"
        >
          <ion-label>
            <ion-icon name="pricetag"></ion-icon>
            {{ lookups?.['tagId']?.[tagId] ?? tagId }}
          </ion-label>
        </ion-chip>
        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectTag(step.data.action.data)"
        >
          <ion-label>
            <ion-icon name="add-outline"></ion-icon>
            Choose tag
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.TRIGGER_FUNCTION">
        <ion-label class="input-label" *ngIf="functionNames?.length">Function name</ion-label>
        <ion-select
          *ngIf="functionNames?.length"
          placeholder="Select function"
          class="input-field"
          interface="popover"
          [(ngModel)]="step.data.action.data.functionName"
          [compareWith]="compareFn"
        >
          <ion-select-option *ngFor="let name of functionNames" [value]="name">
            {{ name }}
          </ion-select-option>
        </ion-select>
        <ion-button color="dark" (click)="editFunctions()" class="btn-small" style="margin-top: 14px">
          <ion-icon name="code-outline" class="padded-icon"></ion-icon>
          {{ functionNames?.length ? 'Edit Functions' : 'Create your first function' }}
        </ion-button>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CONVERSATION_TICKET_TYPE">
        <ion-label class="input-label">Assign ticket type</ion-label>
        <br />

        <ion-chip
          mode="ios"
          class="select-chip select-outline no-margin"
          [outline]="true"
          (click)="selectTicketType(step.data.action.data)"
        >
          <ion-label>
            {{ lookups?.['ticketTypeId']?.[step.data.action.data.ticketTypeId] ?? 'None' }}
            <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_SLACK_USER_GROUP_MEMBERSHIP">
        <div>
          <ion-label class="input-label">Slack User Group to Modify</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            (click)="selectSlackUserGroup(step.data.action.data)"
            style="margin-left: 0"
          >
            <ion-label>
              {{ lookups?.['slackGroupId']?.[step.data.action.data.slackUserGroupId] ?? 'Select user group' }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div>
          <ion-label class="input-label">Users to Add</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            style="margin: 0 5px 0 0"
            *ngFor="let userId of step.data.action.data.userIds; let i = index"
            (click)="removeUserFromList(step.data.action.data, i)"
          >
            <ion-label>
              {{ lookups?.['assigneeId']?.[userId] ?? userId }}
              <ion-icon name="close-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectUserForList(step.data.action.data)"
          >
            <ion-label>
              <ion-icon name="add-outline"></ion-icon>
              Choose users
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.POST_TO_TRIAGE">
        <div>
          <ion-label class="input-label">Triage channel</ion-label>
          <br />

          <div class="flexed-align-center">
            <app-channel-selector
              [channel]="
                step.data.action.data.channelId
                  ? {
                      id: step.data.action.data.channelId,
                      name:
                        lookups?.['slackChannelId']?.[step.data.action.data.channelId] ??
                        step.data.action.data.channelId
                    }
                  : undefined
              "
              (channelDidChange)="onSlackChannelChange($event)"
              [defaultInternalOnly]="true"
              [disabled]="step.data.action.data.createChannel"
              [hideUnlinkButton]="true"
              [hideLinkedToText]="true"
            ></app-channel-selector>

            <ion-button
              color="dark"
              fill="clear"
              class="btn-small"
              (click)="toggleCreateTemporaryTriageChannel(step.data.action.data)"
            >
              <ion-icon
                [name]="step.data.action.data.createChannel ? 'checkbox' : 'square-outline'"
                class="padded-icon"
              ></ion-icon>
              Create temporary channel
            </ion-button>
          </div>
        </div>

        <div style="margin-top: 10px" *ngIf="step.data.action.data.createChannel">
          <ion-label class="input-label">Channel name prefix (optional)</ion-label>
          <br />
          <ion-input
            class="input-field"
            placeholder="Example: 'incident-'"
            [(ngModel)]="step.data.action.data.createChannel.prefix"
          >
          </ion-input>
          <ion-note class="input-label"> Conversation ID will be appended to the prefix entered above. </ion-note>
          <div class="flexed-align-center">
            <ion-toggle [(ngModel)]="step.data.action.data.createChannel.isPrivate"></ion-toggle>
            <ion-label class="input-label">Private channel</ion-label>
          </div>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Tag a user or team</ion-label>
          <br />

          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectAssignee(step.data.action.data.tag)"
          >
            <ion-label>
              {{
                lookups?.['assigneeId']?.[step.data.action.data.tag.entityId] ??
                  lookups?.['groupId']?.[step.data.action.data.tag.entityId] ??
                  lookups?.['userGroupId']?.[step.data.action.data.tag.entityId] ??
                  'No one'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Custom note</ion-label>
          <br />
          <ion-input
            class="input-field"
            placeholder="Add a custom note to the triage message"
            [(ngModel)]="step.data.action.data.note"
          >
          </ion-input>
        </div>

        <div style="margin-top: 10px">
          <ion-label class="input-label">Triage message template</ion-label>
          <br />

          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectTemplate(step.data.action.data)"
          >
            <ion-label>
              {{ lookups?.['templateId']?.[step.data.action.data.templateId] ?? 'None' }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>

      <!-- Add User to Google Group Section -->
      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.ADD_USER_TO_GOOGLE_GROUP">
        <!-- Google Group ID Input -->
        @if (authService.tenant.integrations?.google?.enabled) {
          <div>
            <ion-label class="input-label">Google Group ID</ion-label>
            <br />
            <ion-input
              class="input-field"
              placeholder="Enter Google Group ID (e.g., group@example.com)"
              [(ngModel)]="step.data.action.data.googleGroupId"
            ></ion-input>
          </div>

          <!-- User Source Selection -->
          <div style="margin-top: 10px">
            <ion-label class="input-label">User to add</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectResolvableEntity(step.data.action.data, 'userId', ENTITY_TYPES.USER)"
            >
              <ion-label>
                {{
                  step.data.action.data.userId
                    ? getResolvableEntityLabel(step.data.action.data.userId, ENTITY_TYPES.USER)
                    : 'Select user field'
                }}
                <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <!-- Specific User Selection (Conditional) -->
          <div style="margin-top: 10px" *ngIf="showSpecificEntitySelection(step.data.action.data, 'userId')">
            <ion-label class="input-label">Select specific user</ion-label>
            <br />
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectSpecificEntity(step.data.action.data, 'userId', ENTITY_TYPES.USER)"
            >
              <ion-label>
                {{ lookups?.['assigneeId']?.[step.data.action.data.userId?.value ?? ''] ?? 'Select user' }}
                <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        } @else {
          <ion-button color="dark" routerLink="/admin/apps">
            <ion-icon name="information-circle" class="padded-icon"></ion-icon>
            Connect to Google
          </ion-button>
        }
      </ion-card-content>
      <!-- End Add User to Google Group Section -->

      <ion-card-content *ngSwitchCase="AUTOMATION_ACTION_TYPES.SET_CUSTOM_FIELD">
        <div>
          <ion-label class="input-label"> Set </ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="selectCustomField(step.data.action.data, $event)"
          >
            <ion-label>
              {{ selectedCustomFieldForAction?.label ?? 'None' }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>

          <div
            *ngIf="
              selectedCustomFieldForAction &&
              selectedCustomFieldForAction?.type !== 'user-group-select' &&
              selectedCustomFieldForAction?.type !== 'user-select'
            "
            style="margin-top: 10px"
          >
            <ion-label class="input-label">To</ion-label>
            <br />

            <!-- Standard Input for non-user/user-group fields -->
            <app-automation-custom-field-input
              [customField]="selectedCustomFieldForAction"
              [value]="hydratedCustomFieldValue"
              (valueChange)="onCustomFieldValueChange($event)"
              [projectId]="projectId"
            >
            </app-automation-custom-field-input>
          </div>
        </div>

        <!-- Resolvable Entity Input for user/user-group fields -->
        <div
          *ngIf="
            selectedCustomFieldForAction &&
            (selectedCustomFieldForAction?.type === 'user-group-select' ||
              selectedCustomFieldForAction?.type === 'user-select')
          "
          style="margin-top: 10px"
        >
          <ion-label class="input-label">To</ion-label>
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="
              selectResolvableEntity(
                step.data.action.data,
                'value',
                selectedCustomFieldForAction?.type === 'user-group-select' ? ENTITY_TYPES.USER_GROUP : ENTITY_TYPES.USER
              )
            "
          >
            <ion-label>
              {{
                step.data.action.data.value
                  ? getResolvableEntityLabel(
                      step.data.action.data.value,
                      selectedCustomFieldForAction?.type === 'user-group-select'
                        ? ENTITY_TYPES.USER_GROUP
                        : ENTITY_TYPES.USER
                    )
                  : 'None'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <!-- Specific Entity Selection (Conditional) -->
        <div
          *ngIf="
            selectedCustomFieldForAction &&
            (selectedCustomFieldForAction?.type === 'user-select' ||
              selectedCustomFieldForAction?.type === 'user-group-select') &&
            showSpecificEntitySelection(step.data.action.data, 'value')
          "
          style="margin-top: 10px"
        >
          <ion-label class="input-label"
            >Select specific
            {{ selectedCustomFieldForAction?.type === 'user-select' ? 'user' : 'user group' }}</ion-label
          >
          <br />
          <ion-chip
            mode="ios"
            class="select-chip select-outline no-margin"
            [outline]="true"
            (click)="
              selectSpecificEntity(
                step.data.action.data,
                'value',
                selectedCustomFieldForAction?.type === 'user-select' ? ENTITY_TYPES.USER : ENTITY_TYPES.USER_GROUP
              )
            "
          >
            <ion-label>
              {{
                lookups?.['assigneeId']?.[step.data.action.data.value?.value ?? ''] ??
                  lookups?.['groupId']?.[step.data.action.data.value?.value ?? ''] ??
                  lookups?.['userGroupId']?.[step.data.action.data.value?.value ?? ''] ??
                  'None'
              }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-content>
    </ng-container>
  </ng-container>
</ion-card>
